<h1 mat-dialog-title style="text-align: center;">Delete Confirmation</h1>
<div mat-dialog-content style="text-align: center;">
  <p *ngIf="extraMessage">{{extraMessage}}</p>
  <p>Are you sure?</p>
</div>
<div mat-dialog-actions style="justify-content: center;">
  <button mat-button [mat-dialog-close]="'cancel'">Cancel</button>
  <button mat-button [mat-dialog-close]="'delete'" cdkFocusInitial style="margin-left: 0px;">Delete</button>
</div>